var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriversLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 34,
    viewBox: "0 0 42 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5 -0.25H3.5C1.5925 -0.173333 0.07 1.49417 0 3.58333V30.4167C0.07 32.5058 1.5925 34.1733 3.5 34.25H38.5C40.4075 34.1733 41.93 32.5058 42 30.4167V3.58333C41.9678 2.5779 41.5887 1.62324 40.9392 0.911855C40.2896 0.200469 39.418 -0.214723 38.5 -0.25ZM38.5 30.4167H3.5V3.58333H38.5V30.4167ZM24.5 26.5833V24.1875C24.5 21.0058 18.655 19.3958 15.75 19.3958C12.845 19.3958 7 21.0058 7 24.1875V26.5833H24.5ZM15.75 7.41667C14.5897 7.41667 13.4769 7.9215 12.6564 8.82011C11.8359 9.71872 11.375 10.9375 11.375 12.2083C11.375 12.8376 11.4882 13.4607 11.708 14.042C11.9279 14.6234 12.2502 15.1516 12.6564 15.5966C13.4769 16.4952 14.5897 17 15.75 17C16.3245 17 16.8934 16.8761 17.4242 16.6353C17.955 16.3945 18.4373 16.0415 18.8436 15.5966C19.2498 15.1516 19.5721 14.6234 19.792 14.042C20.0118 13.4607 20.125 12.8376 20.125 12.2083C20.125 11.5791 20.0118 10.956 19.792 10.3746C19.5721 9.79329 19.2498 9.26506 18.8436 8.82011C18.4373 8.37517 17.955 8.02221 17.4242 7.78141C16.8934 7.54061 16.3245 7.41667 15.75 7.41667ZM24.5 7.41667V9.33333H35V7.41667H24.5ZM24.5 11.25V13.1667H35V11.25H24.5ZM24.5 15.0833V17H31.5V15.0833H24.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversLicense);
export default __webpack_public_path__ + "static/media/drivers-license.563732d77a3c48117dff2cf630ebc15b.svg";
export { ForwardRef as ReactComponent };